const BASE_FONT_SIZE = 10;
const BASE_SHEET_WIDTH = 900;
const CHAR_ASPECT_RATIO = 0.525;
const DEFAULT_INPUT_BORDER_WIDTH_IN_EM = 0.2;
const DEFAULT_INPUT_LINE_HEIGHT = 1.25;
const DEFAULT_INPUT_PADDING_IN_EM = 0.85;
const FONT_SIZE_EXTRA_LARGE_IN_EM = 2.5;
const FONT_SIZE_LARGE_IN_EM = 1.8;
const FONT_SIZE_MEDIUM_IN_EM = 1.4;
const FONT_SIZE_SMALL_IN_EM = 1;
const BASE_TABLE_CELL_SIZE_IN_PX = 125;
const BASE_TABLE_CELL_BORDER_WIDTH_IN_PX = 2;
const DEFAULT_LINE_WIDTH_IN_EM = 2;
const MOBILE_BREAKPOINT = 600;
const V1_TO_V2_FONT_SIZE_RATIO = 0.075;

export { BASE_FONT_SIZE, BASE_SHEET_WIDTH, BASE_TABLE_CELL_BORDER_WIDTH_IN_PX, BASE_TABLE_CELL_SIZE_IN_PX, CHAR_ASPECT_RATIO, DEFAULT_INPUT_BORDER_WIDTH_IN_EM, DEFAULT_INPUT_LINE_HEIGHT, DEFAULT_INPUT_PADDING_IN_EM, DEFAULT_LINE_WIDTH_IN_EM, FONT_SIZE_EXTRA_LARGE_IN_EM, FONT_SIZE_LARGE_IN_EM, FONT_SIZE_MEDIUM_IN_EM, FONT_SIZE_SMALL_IN_EM, MOBILE_BREAKPOINT, V1_TO_V2_FONT_SIZE_RATIO };
//# sourceMappingURL=sheet.js.map
